module.exports = __webpack_public_path__ + "static/VC_1-98e0a7d3bda7ec93d2190bf9daf20d4d.png";